export const LOAN_VARIABLES_FORM_PREFIX = 'loanVariablesForm';

export const LOAN_VARIABLES_FIELDS_NAMES = {
  ADD_ONS: `${LOAN_VARIABLES_FORM_PREFIX}.addOns`,
  ADJUSTED_PRICE: `${LOAN_VARIABLES_FORM_PREFIX}.adjustedPrice`,
  APPLY_CPO: `${LOAN_VARIABLES_FORM_PREFIX}.applyCpo`,
  APR: `${LOAN_VARIABLES_FORM_PREFIX}.apr`,
  CASH_DOWN: `${LOAN_VARIABLES_FORM_PREFIX}.cashDown`,
  CONFIRM_BOOK: `${LOAN_VARIABLES_FORM_PREFIX}.confirmBook`,
  GAP: `${LOAN_VARIABLES_FORM_PREFIX}.gap`,
  GUIDEBOOK_VALUE: `${LOAN_VARIABLES_FORM_PREFIX}.guidebookValue`,
  LOAN_TERM: `${LOAN_VARIABLES_FORM_PREFIX}.loanTerm`,
  LOAN_TERMS_LIST: `${LOAN_VARIABLES_FORM_PREFIX}.loanTermsList`,
  MILEAGE: `${LOAN_VARIABLES_FORM_PREFIX}.mileage`,
  MONTHLY_INCOME: `${LOAN_VARIABLES_FORM_PREFIX}.monthlyIncome`,
  MONTHLY_INCOME_FORM: `${LOAN_VARIABLES_FORM_PREFIX}.monthlyIncomeForm`,
  NET_TRADE_IN: `${LOAN_VARIABLES_FORM_PREFIX}.netTradeIn`,
  NET_TRADE_IN_FORM: `${LOAN_VARIABLES_FORM_PREFIX}.netTradeInForm`,
  PAYMENT: `${LOAN_VARIABLES_FORM_PREFIX}.payment`,
  PRICE: `${LOAN_VARIABLES_FORM_PREFIX}.price`,
  REBATES: `${LOAN_VARIABLES_FORM_PREFIX}.rebates`,
  RETAIL_PRICE: `${LOAN_VARIABLES_FORM_PREFIX}.retailPrice`,
  ROUTE_ONE_USER_ID: `${LOAN_VARIABLES_FORM_PREFIX}.routeOneUserId`,
  SALES_FEES_FORM: `${LOAN_VARIABLES_FORM_PREFIX}.salesFeesForm`,
  SAVED_INCOMES: `${LOAN_VARIABLES_FORM_PREFIX}.savedIncomes`,
  STOCK: `${LOAN_VARIABLES_FORM_PREFIX}.stock`,
  TAXES: `${LOAN_VARIABLES_FORM_PREFIX}.taxes`,
  TIER: `${LOAN_VARIABLES_FORM_PREFIX}.vehicleTier`,
  TOTAL_AMOUNT_FINANCED: `${LOAN_VARIABLES_FORM_PREFIX}.totalAmountFinanced`,
  LINE_THREE: `${LOAN_VARIABLES_FORM_PREFIX}.lineThree`,
  DECISION_COMMENTS: `${LOAN_VARIABLES_FORM_PREFIX}.decisionComments`,
  TOTAL_SALES_FEES: `${LOAN_VARIABLES_FORM_PREFIX}.totalSalesFees`,
  VIN: `${LOAN_VARIABLES_FORM_PREFIX}.vin`,
  VSC: `${LOAN_VARIABLES_FORM_PREFIX}.vsc`,
  LTV_CATEGORIES: `${LOAN_VARIABLES_FORM_PREFIX}.ltvCategories`,
  IS_VERIFY_DEAL_BUTTON_DISABLED: `${LOAN_VARIABLES_FORM_PREFIX}.isVerifyDealButtonDisabled`,
  CURRENT_PAYMENT: `${LOAN_VARIABLES_FORM_PREFIX}.currentPayment`,
  PARTICIPATION: `${LOAN_VARIABLES_FORM_PREFIX}.participation`,
  BALLOON_TOGGLE: `${LOAN_VARIABLES_FORM_PREFIX}.balloonToggle`,
  AFG_TRIM: `${LOAN_VARIABLES_FORM_PREFIX}.afgTrim`,
  BALLOON_PAYMENT: `${LOAN_VARIABLES_FORM_PREFIX}.balloonPayment`,
  ANNUAL_MILEAGE: `${LOAN_VARIABLES_FORM_PREFIX}.annualMileage`,
  ENGINE: `${LOAN_VARIABLES_FORM_PREFIX}.engine`,
  LENDER_LIST: `${LOAN_VARIABLES_FORM_PREFIX}.lenderList`,
  CREATE_ADDENDUM: `${LOAN_VARIABLES_FORM_PREFIX}.createAddendum`,
  AFG_SUBMIT_DEAL: `${LOAN_VARIABLES_FORM_PREFIX}.afgSubmitDeal`,
  CONTRACT_DATE: `${LOAN_VARIABLES_FORM_PREFIX}.contractDate`,
  FIRST_PAYMENT_DATE: `${LOAN_VARIABLES_FORM_PREFIX}.firstPaymentDate`,
};
